<template>
    <transition name="layout-fade">
        <v-layout wrap>
            <Navigation/>
            <v-slide-y-transition mode="out-in">
                <router-view/>
            </v-slide-y-transition>
        </v-layout>
    </transition>
</template>

<script>
    import Navigation from './Navigation'

    export default {
        name: 'SEOSMMLayout',
        components: { Navigation },
        created () {
            this.setHeaderTitle('SEO & SMM')
        },
    }
</script>
